import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import {of} from 'rxjs';
import {map} from 'rxjs/operators';
import {
  DonViSetting,
  IDonViSetting,
} from '@entities/don-vi/don-vi-setting.model';
import {DonViService} from '@entities/don-vi/don-vi.service';

@Injectable({providedIn: 'root'})
export class DonViSettingResolver implements Resolve<IDonViSetting> {
  constructor(private service: DonViService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const id = route.params['donVi'] ? route.params['donVi'] : null;
    if (id) {
      return this.service
        .getSetting(id, {exceptAlert: true})
        .pipe(
          map(
            (donVi: HttpResponse<IDonViSetting>) =>
              new DonViSetting(donVi.body),
          ),
        );
    }
    return of(new DonViSetting());
  }
}
